export type PlatformContractSummaryService = {
  id: number;
  channelEnabled: boolean;
  companyContracted: boolean;
};

export type PlatformContractSummaryContract = {
  status: string;
};

export type PlatformContractSummary = {
  scope: {
    companyId: number | null;
    channelId: number | null;
  };
  metrics: {
    servicesInCatalog: number;
    servicesContracted: number;
    activeContracts: number;
  };
  services: PlatformContractSummaryService[];
  contracts: PlatformContractSummaryContract[];
};

export function buildPlatformContractsSummary({
  companyId,
  channelId,
  services,
  contracts,
}: {
  companyId: number | null;
  channelId: number | null;
  services: PlatformContractSummaryService[];
  contracts: PlatformContractSummaryContract[];
}): PlatformContractSummary {
  return {
    scope: {
      companyId,
      channelId,
    },
    metrics: {
      servicesInCatalog: services.filter((service) => service.channelEnabled).length,
      servicesContracted: services.filter((service) => service.companyContracted).length,
      activeContracts: contracts.filter((contract) => contract.status === "active").length,
    },
    services,
    contracts,
  };
}
